import { downloadMedicalConsentService } from "../../services/MedicalConsent";

export function downloadMedicalConsent() {
  return async () => {
    try {
      return await downloadMedicalConsentService();
    } catch (error) {
      return false;
    }
  };
}
